import { Link } from "react-router-dom";

const DropDownThree = () => {
  return (
    <div className="dropDownMenu3">
      <div className="dropDownMenu3Wrapper">
        <div className="col">
          <div className="item">
            <Link className="title">World's News</Link>
            <ul className="list">
              <li>
                <Link> US &amp; Canada</Link>
              </li>
              <li>
                <Link> Europe</Link>
              </li>
              <li>
                <Link> Africa</Link>
              </li>
              <li>
                <Link> Asia</Link>
              </li>
              <li>
                <Link> Middle East</Link>
              </li>
              <li>
                <Link> Asia Pacific</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col">
          <div className="item">
            <Link className="title">Documentation</Link>
            <ul className="list">
              <li>
                <Link> Featured Documentation</Link>
              </li>
              <li>
                <Link> People &amp; Power</Link>
              </li>
              <li>
                <Link> Rebel Education</Link>
              </li>
              <li>
                <Link> Rewind</Link>
              </li>
              <li>
                <Link> Fault Lines</Link>
              </li>
              <li>
                <Link> News 360 Degree World's</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col">
          <div className="item">
            <Link className="title">Sports</Link>
            <ul className="list">
              <li>
                <Link> Football </Link>
              </li>
              <li>
                <Link> Cricket</Link>
              </li>
              <li>
                <Link> Hocky</Link>
              </li>
            </ul>
          </div>

          <div className="item">
            <Link className="title">Movies</Link>
            <ul className="list">
              <li>
                <Link> Hollywood </Link>
              </li>
              <li>
                <Link> Nollywood</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col">
          <div className="item">
            <Link className="title">Business</Link>
            <ul className="list">
              <li>
                <Link> Us Business </Link>
              </li>
              <li>
                <Link> Middle East Business</Link>
              </li>
              <li>
                <Link> Europe Business</Link>
              </li>
            </ul>
          </div>
          <div className="item">
            <Link className="title">Weather</Link>
            <ul className="list">
              <li>
                <Link> North Pole </Link>
              </li>
              <li>
                <Link> South Pole</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col">
          <div className="item">
            <Link className="title">Education</Link>
            <ul className="list">
              <li>
                <Link> Africa Children Education </Link>
              </li>
              <li>
                <Link> Bangladeshi education</Link>
              </li>
              <li>
                <Link> Middle East education</Link>
              </li>
            </ul>
          </div>
          <div className="item">
            <Link className="title">Health</Link>
            <ul className="list">
              <li>
                <Link> Africa Poor Children Healt </Link>
              </li>
              <li>
                <Link> Fitness and Health</Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="col">
          <div className="item">
            <Link className="title">Humanity</Link>
            <ul className="list">
              <li>
                <Link> Help for Syrian Refugees </Link>
              </li>
              <li>
                <Link>Help for Syrian Children </Link>
              </li>
              <li>
                <Link>Help for African Children </Link>
              </li>
            </ul>
          </div>
          <div className="item">
            <Link className="title">Animal</Link>
            <ul className="list">
              <li>
                <Link> African Animal </Link>
              </li>
              <li>
                <Link>Australian Animal </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};
export default DropDownThree;
